import React from 'react';
import logo from "../assets/governor.png";

import { Card, CardBody, CardTitle, CardText } from 'reactstrap';

const Chancellor = () => {
  return (
    <div className="container mt-5 mb-5">
      <Card className="shadow-lg border-0 rounded-4">
        <div className="row g-0">
          <div className="col-md-4 d-flex align-items-center justify-content-center p-4">
            <img
              src={logo}
              alt="कुलाधिपति"
              className="img-fluid rounded-3 shadow-sm"
              style={{ maxHeight: '320px', objectFit: 'cover' }}
            />
          </div>
          <div className="col-md-8">
            <CardBody className="p-4">
              <CardTitle tag="h4" className="text-center mb-4 text-primary fw-bold">
                कुलाधिपति
              </CardTitle>
              <CardText className="fs-5">
                <strong className="text-dark">प्रो. अशीम कुमार घोष</strong><br />
                महामहिम राज्यपाल
              </CardText>
              <hr />
              <CardText className="mt-3">
                <strong>कार्यालय:</strong><br />
                <span>संपर्क - <a href="tel:2740654">2740654</a>, <a href="tel:2740643">2740643</a></span><br />
                <strong>ई-मेल:</strong> <a href="mailto:governor@hry.nic.in">governor@hry.nic.in</a><br />
                <strong>पता:</strong> हरियाणा राज भवन, सैक्टर 6, चण्डीगढ़ – 160019
              </CardText>
            </CardBody>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default Chancellor;
